<template>
  <div style="padding: 20px;width: 100%">
    <el-tabs v-model="activeTab" @tab-click="handleTabClick">
      <!-- 平台通道Tab -->
      <el-tab-pane label="平台通道" name="platform">
        <el-card shadow="hover" style="margin-top: 20px">
          <el-form ref="queryFormRef" :model="queryParams" :inline="true">
            <el-form-item label="支付类型" prop="paymentType">
              <el-select v-model="queryParams.paymentType" placeholder="请选择支付类型" clearable>
                <el-option label="微信支付" value="wechat"></el-option>
                <el-option label="支付宝支付" value="alipay"></el-option>
                <el-option label="Jeepay支付" value="jeepay"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="通道名称" prop="channelName">
              <el-input v-model="queryParams.channelName" placeholder="请输入通道名称" clearable @keyup.enter="handleQuery" />
            </el-form-item>
            <el-form-item label="状态" prop="status">
              <el-select v-model="queryParams.status" placeholder="请选择状态" clearable>
                <el-option label="启用" :value="1"></el-option>
                <el-option label="禁用" :value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
              <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
            </el-form-item>
          </el-form>
        </el-card>

        <el-table
          :data="tableData"
          style="width: 100%; margin-top: 20px"
          v-loading="loading">
          <el-table-column label="ID" prop="id" width="80" align="center"></el-table-column>
          <el-table-column label="支付类型" prop="paymentType" width="120" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.paymentType === 'wechat'" type="success"  effect="dark">微信支付</el-tag>
              <el-tag v-else-if="scope.row.paymentType === 'alipay'" type="primary"  effect="dark">支付宝支付</el-tag>
              <el-tag v-else-if="scope.row.paymentType === 'jeepay'" type="info"  effect="dark">Jeepay支付</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="通道名称" prop="channelName" min-width="150" show-overflow-tooltip></el-table-column>
          <el-table-column label="商户号" prop="merchantNo" width="150" show-overflow-tooltip></el-table-column>
          <el-table-column label="应用ID" prop="appId" width="150" show-overflow-tooltip></el-table-column>
          <!-- <el-table-column label="是否默认" prop="isDefault" width="100" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.isDefault === 1" type="success">是</el-tag>
              <el-tag v-else type="info">否</el-tag>
            </template>
          </el-table-column> -->
          <el-table-column label="状态" prop="status" width="100" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status === 1" type="success"  effect="dark" >启用</el-tag>
              <el-tag v-else type="danger"  effect="dark">禁用</el-tag>
            </template>
          </el-table-column>
          <!-- <el-table-column label="创建时间" prop="createTime" width="180" align="center"></el-table-column> -->
          <!-- <el-table-column label="操作" align="center" width="150" fixed="right">
            <template slot-scope="scope">
              <el-button 
                v-if="scope.row.isDefault !== 1" 
                size="mini" 
                type="success" 
                icon="el-icon-star-on" 
                @click="handleSetDefault(scope.row)">设默认</el-button>
              <span v-else style="color: #67C23A; font-size: 12px">已设为默认</span>
            </template>
          </el-table-column> -->
        </el-table>
      </el-tab-pane>

      <!-- 自定义通道Tab -->
      <el-tab-pane label="自定义通道" name="custom">
        <el-card shadow="hover" style="margin-top: 20px">
          <el-form ref="queryFormRef" :model="queryParams" :inline="true">
            <el-form-item label="支付类型" prop="paymentType">
              <el-select v-model="queryParams.paymentType" placeholder="请选择支付类型" clearable>
                <el-option label="微信支付" value="wechat"  effect="dark"></el-option>
                <el-option label="支付宝支付" value="alipay"  effect="dark"></el-option>
                <el-option label="Jeepay支付" value="jeepay"  effect="dark"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="通道名称" prop="channelName">
              <el-input v-model="queryParams.channelName" placeholder="请输入通道名称" clearable @keyup.enter="handleQuery" />
            </el-form-item>
            <el-form-item label="状态" prop="status">
              <el-select v-model="queryParams.status" placeholder="请选择状态" clearable>
                <el-option label="启用" :value="1"  effect="dark"></el-option>
                <el-option label="禁用" :value="0"  effect="dark"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
              <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
              <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
            </el-form-item>
          </el-form>
        </el-card>

        <el-table
          :data="tableData"
          style="width: 100%; margin-top: 20px"
          v-loading="loading"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="ID" prop="id" width="80" align="center"></el-table-column>
          <el-table-column label="支付类型" prop="paymentType" width="120" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.paymentType === 'wechat'" type="success">微信支付</el-tag>
              <el-tag v-else-if="scope.row.paymentType === 'alipay'" type="primary">支付宝支付</el-tag>
              <el-tag v-else-if="scope.row.paymentType === 'jeepay'" type="info">Jeepay支付</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="通道名称" prop="channelName" min-width="150" show-overflow-tooltip></el-table-column>
          <el-table-column label="商户号" prop="merchantNo" width="150" show-overflow-tooltip></el-table-column>
          <el-table-column label="应用ID" prop="appId" width="150" show-overflow-tooltip></el-table-column>
          <el-table-column label="是否默认" prop="isDefault" width="100" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.isDefault === 1" type="success"  effect="dark">是</el-tag>
              <el-tag v-else type="info"  effect="dark">否</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="状态" prop="status" width="100" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status === 1" type="success"  effect="dark">启用</el-tag>
              <el-tag v-else type="danger"  effect="dark">禁用</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="排序" prop="sortOrder" width="80" align="center"></el-table-column>
          <el-table-column label="创建时间" prop="createTime" width="180" align="center"></el-table-column>
          <el-table-column label="操作" align="center" width="250" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleUpdate(scope.row)">修改</el-button>
              <el-button 
                v-if="scope.row.isDefault !== 1" 
                size="mini" 
                type="success" 
                icon="el-icon-star-on" 
                @click="handleSetDefault(scope.row)">设默认</el-button>
              <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>

    <el-pagination
      background
      layout="prev, pager, next, total"
      :page-size="queryParams.pageSize"
      :current-page="queryParams.pageNum"
      @current-change="currentChange"
      :total="total"
      style="margin-top: 20px; text-align: right">
    </el-pagination>

    <!-- 添加或修改支付通道配置对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="800px"
      @close="cancel">
      <el-form ref="paymentChannelFormRef" :model="form" :rules="rules" label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="支付类型" prop="paymentType">
              <el-select v-model="form.paymentType" placeholder="请选择支付类型" style="width: 100%">
                <el-option label="微信支付" value="wechat"></el-option>
                <el-option label="支付宝支付" value="alipay"></el-option>
                <el-option label="Jeepay支付" value="jeepay"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="通道名称" prop="channelName">
              <el-input v-model="form.channelName" placeholder="请输入通道名称"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="商户号" prop="merchantNo">
              <el-input v-model="form.merchantNo" placeholder="请输入商户号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商户密钥" prop="merchantKey">
              <el-input v-model="form.merchantKey" type="password" show-password placeholder="请输入商户密钥"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="应用ID" prop="appId">
              <el-input v-model="form.appId" placeholder="请输入应用ID（微信/支付宝）"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="应用密钥" prop="appSecret">
              <el-input v-model="form.appSecret" type="password" show-password placeholder="请输入应用密钥"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="应用密钥" prop="appSecret">
              <el-input v-model="form.appSecret" type="password" show-password placeholder="请输入应用密钥"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="API密钥" prop="apiKey">
              <el-input v-model="form.apiKey" type="password" show-password placeholder="请输入API密钥"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="支付接口地址" prop="apiUrl">
              <el-input v-model="form.apiUrl" placeholder="请输入支付接口地址"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="异步通知地址" prop="notifyUrl">
              <el-input v-model="form.notifyUrl" placeholder="请输入异步通知地址"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="同步返回地址" prop="returnUrl">
              <el-input v-model="form.returnUrl" placeholder="请输入同步返回地址"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否默认" prop="isDefault">
              <el-radio-group v-model="form.isDefault">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="状态" prop="status">
              <el-radio-group v-model="form.status">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="排序顺序" prop="sortOrder">
              <el-input-number v-model="form.sortOrder" :min="0" placeholder="排序顺序" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="备注说明" prop="remark">
          <el-input v-model="form.remark" type="textarea" :rows="3" placeholder="请输入备注说明"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="submitForm" :loading="buttonLoading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'PaymentChannel',
  data() {
    return {
      activeTab: 'platform', // 当前激活的tab：platform-平台通道，custom-自定义通道
      loading: false,
      buttonLoading: false,
      tableData: [],
      total: 0,
      dialogVisible: false,
      dialogTitle: '添加支付通道配置',
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        userId: null, // 当前用户ID，查询时自动设置
        channelType: 'platform', // 根据tab自动设置
        paymentType: null,
        channelName: null,
        status: null
      },
      form: {
        id: null,
        userId: null, // 当前用户ID，新增时自动设置
        channelType: null,
        paymentType: null,
        channelName: null,
        merchantNo: null,
        merchantKey: null,
        appId: null,
        appSecret: null,
        apiKey: null,
        notifyUrl: null,
        returnUrl: null,
        apiUrl: null,
        isDefault: 0,
        status: 1,
        sortOrder: 0,
        remark: null
      },
      rules: {
        paymentType: [
          { required: true, message: '请选择支付类型', trigger: 'change' }
        ],
        channelName: [
          { required: true, message: '请输入通道名称', trigger: 'blur' }
        ]
      },
      multipleSelection: []
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    /** Tab切换事件 */
    handleTabClick(tab) {
      // 根据tab设置通道类型
      this.queryParams.channelType = tab.name
      this.queryParams.pageNum = 1
      this.getList()
    },
    
    /** 查询支付通道配置列表 */
    getList() {
      this.loading = true
      // 根据当前tab设置查询参数
      if (this.activeTab === 'platform') {
        // 平台通道：查询userId=0的平台通道
        this.queryParams.userId = 0
        this.queryParams.channelType = 'platform'
      } else {
        // 自定义通道：查询当前用户的自定义通道
        const userId = this.userStore?.userInfo?.id
        if (userId) {
          this.queryParams.userId = userId
        }
        this.queryParams.channelType = 'custom'
      }
      
      this.$http2({
        url: `/klgeek/paymentChannel/list?pageNum=${this.queryParams.pageNum}&pageSize=${this.queryParams.pageSize}`,
        method: 'get',
        params: this.queryParams
      }).then((res) => {
        this.tableData = res.rows || []
        this.total = res.total || 0
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    
    /** 重置按钮操作 */
    resetQuery() {
      // 根据当前tab设置查询参数
      if (this.activeTab === 'platform') {
        this.queryParams = {
          pageNum: 1,
          pageSize: 10,
          userId: 0, // 平台通道
          channelType: 'platform',
          paymentType: null,
          channelName: null,
          status: null
        }
      } else {
        this.queryParams = {
          pageNum: 1,
          pageSize: 10,
          userId: this.userStore?.userInfo?.id || null, // 自定义通道
          channelType: 'custom',
          paymentType: null,
          channelName: null,
          status: null
        }
      }
      this.$refs.queryFormRef.resetFields()
      this.getList()
    },
    
    /** 分页变化 */
    currentChange(num) {
      if (num) {
        this.queryParams.pageNum = num
      }
      this.getList()
    },
    
    /** 多选框选中数据 */
    handleSelectionChange(selection) {
      this.multipleSelection = selection
    },
    
    /** 新增按钮操作 */
    handleAdd() {
      this.resetForm()
      this.dialogTitle = '添加自定义支付通道配置'
      this.dialogVisible = true
      // 设置当前用户ID和通道类型（固定为自定义通道）
      const userId = this.userStore?.userInfo?.id
      if (userId) {
        this.form.userId = userId
      }
      this.form.channelType = 'custom' // 固定为自定义通道
    },
    
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.resetForm()
      this.dialogTitle = '修改自定义支付通道配置'
      this.dialogVisible = true
      
      this.$http2({
        url: `/klgeek/paymentChannel/${row.id}`,
        method: 'get'
      }).then((res) => {
        if (res.data) {
          Object.assign(this.form, res.data)
          // 确保通道类型为custom
          this.form.channelType = 'custom'
        }
      })
    },
    
    /** 提交按钮 */
    submitForm() {
      this.$refs.paymentChannelFormRef.validate((valid) => {
        if (valid) {
          this.buttonLoading = true
          const url = this.form.id 
            ? `/klgeek/paymentChannel` 
            : `/klgeek/paymentChannel`
          const method = this.form.id ? 'put' : 'post'
          
          this.$http2({
            url: url,
            method: method,
            data: this.form
          }).then(() => {
            this.$message.success('操作成功')
            this.dialogVisible = false
            this.getList()
            this.buttonLoading = false
          }).catch(() => {
            this.buttonLoading = false
          })
        }
      })
    },
    
    /** 删除按钮操作 */
    handleDelete(row) {
      this.$confirm('是否确认删除该支付通道配置？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http2({
          url: `/klgeek/paymentChannel/${row.id}`,
          method: 'delete'
        }).then(() => {
          this.$message.success('删除成功')
          this.getList()
        })
      }).catch(() => {})
    },
    
    /** 设置默认通道 */
    handleSetDefault(row) {
      this.$confirm('是否确认设置该通道为默认通道？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http2({
          url: `/klgeek/paymentChannel/setDefault/${row.id}`,
          method: 'put'
        }).then(() => {
          this.$message.success('设置成功')
          this.getList()
        })
      }).catch(() => {})
    },
    
    /** 取消按钮 */
    cancel() {
      this.dialogVisible = false
      this.resetForm()
    },
    
    /** 表单重置 */
    resetForm() {
      this.form = {
        id: null,
        userId: this.userStore?.userInfo?.id || null,
        channelType: 'custom', // 固定为自定义通道
        paymentType: null,
        channelName: null,
        merchantNo: null,
        merchantKey: null,
        appId: null,
        appSecret: null,
        apiKey: null,
        notifyUrl: null,
        returnUrl: null,
        apiUrl: null,
        isDefault: 0,
        status: 1,
        sortOrder: 0,
        remark: null
      }
      if (this.$refs.paymentChannelFormRef) {
        this.$refs.paymentChannelFormRef.resetFields()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.dialog-footer {
  text-align: right;
}
</style>
